import React, { createContext, useContext } from "react";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const flightLocations = [
        {
            id: 1,
            flight_code: "CYYG",
            city_name: "Charlottetown",
            province: "Prince Edward Island"
        },
        {
            id: 2,
            flight_code: "CYQM",
            city_name: "Moncton/Greater Moncton International",
            province: "New Brunswick"
        },
        {
            id: 3,
            flight_code: "CYSJ",
            city_name: "Saint John",
            province: "New Brunswick"
        },
        {
            id: 4,
            flight_code: "CYFC",
            city_name: "Fredericton International",
            province: "New Brunswick"
        },
        {
            id: 5,
            flight_code: "CYHZ",
            city_name: "Halifax Robert L. Stanfield International",
            province: "Nova Scotia"
        },
        {
            id: 6,
            flight_code: "CYFB",
            city_name: "Iqaluit",
            province: "Nunavut"
        },
        {
            id: 7,
            flight_code: "CYRT",
            city_name: "Rankin Inlet",
            province: "Nunavut"
        },
        {
            id: 8,
            flight_code: "CYOW",
            city_name: "Ottawa/Macdonald-Cartier International",
            province: "Ontario"
        },
        {
            id: 9,
            flight_code: "CYOO",
            city_name: "Oshawa",
            province: "Ontario"
        },
        {
            id: 10,
            flight_code: "CYKZ",
            city_name: "Toronto/Buttonville Municipal",
            province: "Ontario"
        },
        {
            id: 11,
            flight_code: "CYTZ",
            city_name: "Toronto City Centre",
            province: "Ontario"
        },
        {
            id: 12,
            flight_code: "CYYZ",
            city_name: "Toronto Pearson International",
            province: "Ontario"
        },
        {
            id: 13,
            flight_code: "CYHM",
            city_name: "Hamilton",
            province: "Ontario"
        },
        {
            id: 14,
            flight_code: "CYKF",
            city_name: "Kitchener/Waterloo",
            province: "Ontario"
        },
        {
            id: 15,
            flight_code: "CYXU",
            city_name: "London",
            province: "Ontario"
        },
        {
            id: 16,
            flight_code: "CYQG",
            city_name: "Windsor",
            province: "Ontario"
        },
        {
            id: 17,
            flight_code: "CYAM",
            city_name: "Sault Ste Marie",
            province: "Ontario"
        },
        {
            id: 18,
            flight_code: "CYQT",
            city_name: "Thunder Bay",
            province: "Ontario"
        },
        {
            id: 19,
            flight_code: "CYQK",
            city_name: "Kenora",
            province: "Ontario"
        },
        {
            id: 20,
            flight_code: "CYXL",
            city_name: "Sioux Lookout",
            province: "Ontario"
        },
        {
            id: 21,
            flight_code: "CYSN",
            city_name: "St. Catharines Niagara District",
            province: "Ontario"
        },
        {
            id: 22,
            flight_code: "CYTS",
            city_name: "Timmins Victor M. Power",
            province: "Ontario"
        },
        {
            id: 23,
            flight_code: "CYSB",
            city_name: "Sudbury",
            province: "Ontario"
        },
        {
            id: 24,
            flight_code: "CYGK",
            city_name: "Kingston",
            province: "Ontario"
        },
        {
            id: 25,
            flight_code: "CYYB",
            city_name: "North Bay",
            province: "Ontario"
        },
        {
            id: 26,
            flight_code: "CYYT",
            city_name: "St John's Intl",
            province: "Newfoundland and Labrador"
        },
        {
            id: 27,
            flight_code: "CYQX",
            city_name: "Gander International",
            province: "Newfoundland and Labrador"
        },
        {
            id: 28,
            flight_code: "CYWK",
            city_name: "Wabush",
            province: "Newfoundland and Labrador"
        },
        {
            id: 29,
            flight_code: "CYDF",
            city_name: "Deer Lake",
            province: "Newfoundland and Labrador"
        },
        {
            id: 30,
            flight_code: "CYZF",
            city_name: "Yellowknife",
            province: "Northwest Territories"
        },
        {
            id: 31,
            flight_code: "CYVQ",
            city_name: "Norman Wells",
            province: "Northwest Territories"
        },
        {
            id: 32,
            flight_code: "CYEV",
            city_name: "Inuvik (Mike Zubko)",
            province: "Northwest Territories"
        },
        {
            id: 33,
            flight_code: "CYEY",
            city_name: "Aéroport Magny d'Amos",
            province: "Quebec"
        },
        {
            id: 34,
            flight_code: "CTF3",
            city_name: "Aéroport de Causapscal",
            province: "Quebec"
        },
        {
            id: 35,
            flight_code: "CYML",
            city_name: "Aéroport de Charlevoix",
            province: "Quebec"
        },
        {
            id: 36,
            flight_code: "CYDO",
            city_name: "Aéroport Lac-Saint-Jean",
            province: "Quebec"
        },
        {
            id: 37,
            flight_code: "CSC3",
            city_name: "Aéroport de Drummondville",
            province: "Quebec"
        },
        {
            id: 38,
            flight_code: "CTG3",
            city_name: "Aéroport du Rocher-Percé (Pabok)",
            province: "Quebec"
        },
        {
            id: 39,
            flight_code: "CYFE",
            city_name: "Aéroport de Forestville",
            province: "Quebec"
        },
        {
            id: 40,
            flight_code: "CTH3",
            city_name: "Aéroport de Grandes-Bergeronnes",
            province: "Quebec"
        },
        {
            id: 41,
            flight_code: "CTA3",
            city_name: "Aéroport de  l'Île aux Coudres",
            province: "Quebec"
        },
        {
            id: 42,
            flight_code: "CSG3",
            city_name: "Aéroport de Joliette",
            province: "Quebec"
        },
        {
            id: 43,
            flight_code: "CSR8",
            city_name: "Aéroport de La Sarre",
            province: "Quebec"
        },
        {
            id: 44,
            flight_code: "CYLQ",
            city_name: "Aéroport de La Tuque",
            province: "Quebec"
        },
        {
            id: 45,
            flight_code: "CSL3",
            city_name: "Aéroport de Lac-à-la-Tortue",
            province: "Quebec"
        },
        {
            id: 46,
            flight_code: "CSC5",
            city_name: "Aéroport de Lac-Etchemin",
            province: "Quebec"
        },
        {
            id: 47,
            flight_code: "CSE4",
            city_name: "Aéroport de Lachute",
            province: "Quebec"
        },
        {
            id: 48,
            flight_code: "CSJ4",
            city_name: "Aéroport de Louiseville",
            province: "Quebec"
        },
        {
            id: 49,
            flight_code: "CYMW",
            city_name: "Aéroport de Maniwaki",
            province: "Quebec"
        },
        {
            id: 50,
            flight_code: "CYNM",
            city_name: "Aéroport de Matagami",
            province: "Quebec"
        },
        {
            id: 51,
            flight_code: "CYME",
            city_name: "Aéroport Russell-Burnett",
            province: "Quebec"
        },
        {
            id: 52,
            flight_code: "CSD4",
            city_name: "Aéroport de Mont-Laurier",
            province: "Quebec"
        },
        {
            id: 53,
            flight_code: "CST3",
            city_name: "Aérodrome Montréal/Saint-Lazare",
            province: "Quebec"
        },
        {
            id: 54,
            flight_code: "CYPP",
            city_name: "Aéroport de Parent",
            province: "Quebec"
        },
        {
            id: 55,
            flight_code: "CYXK",
            city_name: "Aéroport de Rimouski",
            province: "Quebec"
        },
        {
            id: 56,
            flight_code: "CYRI",
            city_name: "Aéroport de Rivière-du-Loup",
            province: "Quebec"
        },
        {
            id: 57,
            flight_code: "CTA4",
            city_name: "Aérodrome Saint-Bruno-de-Guigues",
            province: "Quebec"
        },
        {
            id: 58,
            flight_code: "CSY4",
            city_name: "Aérodrome Saint-Donat",
            province: "Quebec"
        },
        {
            id: 59,
            flight_code: "CSH5",
            city_name: "Aérodrome Saint-Ferdinand",
            province: "Quebec"
        },
        {
            id: 60,
            flight_code: "CSZ4",
            city_name: "Aérodrome de Saint-Frédéric",
            province: "Quebec"
        },
        {
            id: 61,
            flight_code: "CYSG",
            city_name: "Aérodrome de Saint-Georges",
            province: "Quebec"
        },
        {
            id: 62,
            flight_code: "CSP5",
            city_name: "Aérodrome de Saint-Mathias",
            province: "Quebec"
        },
        {
            id: 63,
            flight_code: "CSM5",
            city_name: "Aérodrome de Saint-Michel-des-Saints",
            province: "Quebec"
        },
        {
            id: 64,
            flight_code: "CSK5",
            city_name: "Aérodrome Saint-Raymond/Paquet",
            province: "Quebec"
        },
        {
            id: 65,
            flight_code: "CYSZ",
            city_name: "Aérodrome Sainte-Anne-des-Monts",
            province: "Quebec"
        },
        {
            id: 66,
            flight_code: "CSD3",
            city_name: "Aérodrome Sallaberry-de-Valleyfield",
            province: "Quebec"
        },
        {
            id: 67,
            flight_code: "CYSC",
            city_name: "Aéroport de Sherbrooke",
            province: "Quebec"
        },
        {
            id: 68,
            flight_code: "CSY3",
            city_name: "Aéroport de Sorel",
            province: "Quebec"
        },
        {
            id: 69,
            flight_code: "CSM3",
            city_name: "Aéroport de Thetford Mines",
            province: "Quebec"
        },
        {
            id: 70,
            flight_code: "CYMU",
            city_name: "Aéroport d'Umiujaq",
            province: "Quebec"
        },
        {
            id: 71,
            flight_code: "CSR3",
            city_name: "Aéroport régional André-Fortin de Victoriaville",
            province: "Quebec"
        },
        {
            id: 72,
            flight_code: "CSU5",
            city_name: "Aéroport de Weymontachie",
            province: "Quebec"
        },
        {
            id: 73,
            flight_code: "CCU2",
            city_name: "Aérodrome Saint-Cuthbert (AirPro)",
            province: "Quebec"
        },
        {
            id: 74,
            flight_code: "CYKO",
            city_name: "Aéroport d'Akulivik",
            province: "Quebec"
        },
        {
            id: 75,
            flight_code: "CYTF",
            city_name: "Aéroport d'Alma",
            province: "Quebec"
        },
        {
            id: 76,
            flight_code: "CYLA",
            city_name: "Aéroport d' Aupaluk",
            province: "Quebec"
        },
        {
            id: 77,
            flight_code: "CYBC",
            city_name: "Aéroport de Baie-Comeau",
            province: "Quebec"
        },
        {
            id: 78,
            flight_code: "CYVB",
            city_name: "Aéroport de Bonaventure",
            province: "Quebec"
        },
        {
            id: 79,
            flight_code: "CZBM",
            city_name: "Aéroport Bromont",
            province: "Quebec"
        },
        {
            id: 80,
            flight_code: "CYHR",
            city_name: "Aéroport de Chevery",
            province: "Quebec"
        },
        {
            id: 81,
            flight_code: "CYMT",
            city_name: "Aéroport de Chibougamau-Chapais",
            province: "Quebec"
        },
        {
            id: 82,
            flight_code: "CYRC",
            city_name: "Aéroport de Saint-Honoré",
            province: "Quebec"
        },
        {
            id: 83,
            flight_code: "CSU2",
            city_name: "Aéroport de Chisasibi",
            province: "Quebec"
        },
        {
            id: 84,
            flight_code: "CZEM",
            city_name: "Aéroport de la rivière Eastmain",
            province: "Quebec"
        },
        {
            id: 85,
            flight_code: "CYGP",
            city_name: "Aéroport Michel-Pouliot de Gaspé",
            province: "Quebec"
        },
        {
            id: 86,
            flight_code: "CYGV",
            city_name: "Aéroport de Havre-Saint-Pierre",
            province: "Quebec"
        },
        {
            id: 87,
            flight_code: "CYGR",
            city_name: "Aéroport des Îles-de-la-Madeleine",
            province: "Quebec"
        },
        {
            id: 88,
            flight_code: "CYPH",
            city_name: "Aéroport d'Inukjuak",
            province: "Quebec"
        },
        {
            id: 89,
            flight_code: "CSH2",
            city_name: "Aéroport Îsle-aux-Grues",
            province: "Quebec"
        },
        {
            id: 90,
            flight_code: "CYIK",
            city_name: "Aéroport d'Ivujivik",
            province: "Quebec"
        },
        {
            id: 91,
            flight_code: "CYLU",
            city_name: "Aéroport de Kangiqsualujjuaq  (Georges River)",
            province: "Quebec"
        },
        {
            id: 92,
            flight_code: "CYKG",
            city_name: "Aéroport de Kangiqsujuaq (Wakeham Bay)",
            province: "Quebec"
        },
        {
            id: 93,
            flight_code: "CYAS",
            city_name: "Aéroport de Kangirsuk",
            province: "Quebec"
        },
        {
            id: 94,
            flight_code: "CYVP",
            city_name: "Aéroport de Kuujjuaq",
            province: "Quebec"
        },
        {
            id: 95,
            flight_code: "CYGW",
            city_name: "Aéroport de Kuujjuarapik",
            province: "Quebec"
        },
        {
            id: 96,
            flight_code: "CYGL",
            city_name: "Aéroport de Radisson Grande-Rivière",
            province: "Quebec"
        },
        {
            id: 97,
            flight_code: "CTT5",
            city_name: "Aéroport de La Romaine",
            province: "Quebec"
        },
        {
            id: 98,
            flight_code: "CTU5",
            city_name: "Aéroport de La Tabatière",
            province: "Quebec"
        },
        {
            id: 99,
            flight_code: "CYBX",
            city_name: "Aéroport de Lourdes-de-Blanc-Sablon",
            province: "Quebec"
        },
        {
            id: 100,
            flight_code: "CYYY",
            city_name: "Aéroport  de Mont-Joli",
            province: "Quebec"
        },
        {
            id: 101,
            flight_code: "CSE5",
            city_name: "Aéroport  de Montmagny",
            province: "Quebec"
        },
        {
            id: 102,
            flight_code: "CYMX",
            city_name: "Aéroport international Montréal-Mirabel",
            province: "Quebec"
        },
        {
            id: 103,
            flight_code: "CYUL",
            city_name: "Aéroport international Pierre-Elliott-Trudeau de Montréal",
            province: "Quebec"
        },
        {
            id: 104,
            flight_code: "CYHU",
            city_name: "Aéroport de Saint-Hubert",
            province: "Quebec"
        },
        {
            id: 105,
            flight_code: "CYNA",
            city_name: "Aéroport de Natashquan",
            province: "Quebec"
        },
        {
            id: 106,
            flight_code: "CYND",
            city_name: "Aéroport exécutif Gatineau-Ottawa",
            province: "Quebec"
        },
        {
            id: 107,
            flight_code: "CYPN",
            city_name: "Aéroport de Port-Menier",
            province: "Quebec"
        },
        {
            id: 108,
            flight_code: "CYPX",
            city_name: "Aéroport de Puvirnituq",
            province: "Quebec"
        },
        {
            id: 109,
            flight_code: "CYHA",
            city_name: "Aéroport de Quaqtaq",
            province: "Quebec"
        },
        {
            id: 110,
            flight_code: "CYQB",
            city_name: "Aéroport international Jean-Lessage de Québec",
            province: "Quebec"
        },
        {
            id: 111,
            flight_code: "CYRJ",
            city_name: "Aéroport de Roberval",
            province: "Quebec"
        },
        {
            id: 112,
            flight_code: "CYUY",
            city_name: "Aéroport de Rouyn-Noranda",
            province: "Quebec"
        },
        {
            id: 113,
            flight_code: "CYIF",
            city_name: "Aéroport de Saint-Augustin",
            province: "Quebec"
        },
        {
            id: 114,
            flight_code: "CYJN",
            city_name: "Aéroport de Saint-Jean-sur-Richelieu",
            province: "Quebec"
        },
        {
            id: 115,
            flight_code: "CYZG",
            city_name: "Aéroport de Salluit",
            province: "Quebec"
        },
        {
            id: 116,
            flight_code: "CYKL",
            city_name: "Aéroport de Schefferville",
            province: "Quebec"
        },
        {
            id: 117,
            flight_code: "CYZV",
            city_name: "Aéroport de Sept-Îles",
            province: "Quebec"
        },
        {
            id: 118,
            flight_code: "CYTQ",
            city_name: "Aéroport de Tasiujaq",
            province: "Quebec"
        },
        {
            id: 119,
            flight_code: "CTB6",
            city_name: "Aéroport de Tête-à-la-Baleine",
            province: "Quebec"
        },
        {
            id: 120,
            flight_code: "CYRQ",
            city_name: "Aéroport de Trois-Rivières",
            province: "Quebec"
        },
        {
            id: 121,
            flight_code: "CYVO",
            city_name: "Aéroport de Val-d'Or",
            province: "Quebec"
        },
        {
            id: 122,
            flight_code: "CYKQ",
            city_name: "Aéroport de Waskaganish",
            province: "Quebec"
        },
        {
            id: 123,
            flight_code: "CYNC",
            city_name: "Aéroport de Wemindji",
            province: "Quebec"
        }
    ];

    const serviceList = [
        {
            id: 1,
            titleButton: "airTaxi"
        },
        {
            id: 2,
            titleButton: "cargo"
        },
        {
            id: 3,
            titleButton: "pilotTraining"
        },
        {
            id: 4,
            titleButton: "experience"
        },
    ];

    // Transform station data
    const formattedLocations = flightLocations.map((station) => ({
        value: station.flight_code,
        label: `${station.flight_code}, ${station.city_name} (${station.province})`,
    }));

    return (
        <DataContext.Provider value={{ formattedLocations, serviceList }}>
            {children}
        </DataContext.Provider>
    );
};

export const useData = () => {
    return useContext(DataContext);
};
